module.exports = __webpack_public_path__ + "img/Logistics.dd14911f.png";